import { Fragment, memo, ReactElement } from 'react';
import AccordionFilterAccordionAct from './accordions/filter-act';
import { Form, Formik } from 'formik';
import { ResearchAct } from 'civil-status/view-models/research-category-form';
import * as yup from 'yup';
import { idActRegex } from 'shell/constants/regex';
import { DateTime } from 'luxon';
// import { MUNICIPALITY_MILANO } from 'civil-status/constants/municipality-milano';

const validationSchemaResearchAct = yup
  .object({
    idAct: yup.string().nullable().matches(idActRegex, 'Formato non corretto'),
    dateStart: yup.date().nullable().typeError('Data non valida'),
    dateEnd: yup
      .date()
      .nullable()
      .typeError('Data non valida')
      .when('dateStart', (dateStart, formvalidationSchema) =>
        dateStart && dateStart?.toString() !== 'Invalid Date'
          ? formvalidationSchema.min(
              dateStart,
              'La data deve essere maggiore o uguale della Data inizio'
            )
          : formvalidationSchema.nullable()
      ),
  })
  .test('dateEnd', 'Campo obbligatorio', (values) => {
    const valuesCasted = (values || {}) as unknown as ResearchAct;

    if (
      valuesCasted.dateEnd &&
      valuesCasted.dateEnd?.toString() !== 'Invalid Date' &&
      valuesCasted.dateStart &&
      valuesCasted.dateStart?.toString() !== 'Invalid Date'
    ) {
      const dateStart = DateTime.fromISO(valuesCasted.dateStart as unknown as string);
      const dateEnd = DateTime.fromISO(valuesCasted.dateEnd as unknown as string);

      // se abbiamo entrambe le date effettuare controllo
      if (dateStart.plus({ month: 1 }) > dateEnd) {
        // range massimo un mese
        return new yup.ValidationError(
          'La data può essere maggiore al massimo di un mese',
          undefined,
          'dateEnd'
        );
      }
      return true;
    }

    return true;
  });

interface FilterAccordionActProps {
  openAct?: boolean;
  setOpenAct: (value: boolean) => void;
  idCat?: string;
  handleSubmitResearchAct: (values: ResearchAct) => void;
  initialValues?: ResearchAct;
  isWithoutInitialContext?: boolean;
  disabledRegister?: boolean;
  disabledMunicipality?: boolean;
}

const FilterAccordionActComponent = ({
  openAct,
  setOpenAct,
  idCat,
  handleSubmitResearchAct,
  initialValues,
  disabledRegister,
  disabledMunicipality,
  isWithoutInitialContext,
}: FilterAccordionActProps): ReactElement => {
  return (
    <Fragment>
      <Formik
        key="form-filter"
        initialValues={
          initialValues ||
          ({
            idCat: undefined,
            dateEnd: undefined,
            dateStart: undefined,
            idAct: undefined,
            // Commentato forzatura di default per issue-3434
            // municipality: MUNICIPALITY_MILANO,
            stateAct: undefined,
            idEvent: undefined,
          } as ResearchAct)
        }
        onSubmit={handleSubmitResearchAct}
        validateOnMount
        validationSchema={validationSchemaResearchAct}
      >
        <Form>
          <AccordionFilterAccordionAct
            open={openAct}
            setOpen={setOpenAct}
            idCat={idCat}
            handleSubmitResearchAct={handleSubmitResearchAct}
            disabledRegister={disabledRegister}
            disabledMunicipality={disabledMunicipality}
            isWithoutInitialContext={isWithoutInitialContext}
          />
        </Form>
      </Formik>
    </Fragment>
  );
};

FilterAccordionActComponent.displayName =
  'Practice Research - Filter Practice component - FilterAccordionAct';

const FilterAccordionAct = memo(FilterAccordionActComponent);

export default FilterAccordionAct;
